import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckCircle2 } from 'lucide-react';
import { useVisitorGeo } from '../hooks/useVisitorGeo';
import { formatVisitorDate } from '../utils/geo';
export function FinalCTASection() {
  const checkoutUrl = 'https://pay.hotmart.com/F104765975P?checkoutMode=10';
  const geo = useVisitorGeo();
  const todayLabel = formatVisitorDate(geo.timezone);
  return <section className="py-16 md:py-24 px-4 bg-forest text-white relative" data-id="element-73" data-mp="2ze0mti0nm8j2">
      <div className="max-w-3xl mx-auto text-center" data-id="element-74" data-mp="34cle2rxxhhvd">
        <h2 className="font-serif text-4xl md:text-5xl font-bold text-gold mb-8" data-id="element-75" data-mp="34dd6xv0551hy">
          Es Tu Momento
        </h2>

        <div className="space-y-4 text-lg md:text-xl text-cream/90 mb-12" data-id="element-76" data-mp="39add05wzq492">
          <p data-id="element-77" data-mp="3e36kh1jufqou">
            Durante demasiado tiempo has buscado la solución en lo que comes al
            mediodía.
          </p>
          <p className="font-bold text-white" data-id="element-78" data-mp="2gkwr7r3vlllt">
            La solución siempre estuvo en lo que comes de noche.
          </p>
          <p data-id="element-79" data-mp="26ur7578mugug">
            Tienes el método ahora mismo. A $15.90 USD. Con garantía total de
            30 días.
          </p>
          <p className="italic text-gold" data-id="element-80" data-mp="21wz4pjad3cc0">
            No hay razón para esperar una semana más. Una noche más. Un espejo
            más.
          </p>
        </div>

        <div className="bg-white rounded-2xl p-6 md:p-10 shadow-2xl text-dark max-w-xl mx-auto" data-id="element-81" data-mp="1s6ea06xt6ryd">
          <div className="mb-6" data-id="element-82" data-mp="1o4j6qwwbi4hy">
            <p className="text-sm font-bold text-urgency uppercase tracking-wider mb-2" data-id="element-83" data-mp="1o5kkj94px53d">
              Disponible hoy: {todayLabel}
            </p>
            <div className="flex items-center justify-center gap-3" data-id="element-84" data-mp="1j7svqnzddz3e">
              <span className="text-2xl text-dark/40 line-through font-bold" data-id="element-85" data-mp="1e6vd6aag731d">
                $32.90
              </span>
              <span className="text-5xl font-serif font-bold text-forest" data-id="element-86" data-mp="199d5soc2wvvh">
                $15.90 <span className="text-xl" data-id="element-87" data-mp="38jl9eyoagobx">USD</span>
              </span>
            </div>
          </div>

          <CTAButton text="OBTENER MI PROTOCOLO AHORA" href={checkoutUrl} variant="primary" className="text-xl py-4 mb-3" data-id="element-88" data-mp="33m2umrnlbew0" />

          <p className="text-xs text-dark/60 mb-6 max-w-md mx-auto leading-relaxed" data-id="element-89" data-mp="16of2qvunspjw">
            En la próxima página de pago podrás pagar en tu moneda local y verás
            la conversión automática del precio.
          </p>

          <div className="text-sm text-dark/70 space-y-2 text-left bg-cream p-4 rounded-xl" data-id="element-90" data-mp="wuogzypx2t7w">
            <p className="font-bold text-center mb-2 text-forest" data-id="element-91" data-mp="1kkiri9mrk5oz">
              ¿Aún tienes dudas? Recuerda:
            </p>
            <div className="grid grid-cols-1 gap-2" data-id="element-92" data-mp="1bm74sip0ps1t">
              <p className="flex items-center gap-2" data-id="element-93" data-mp="1bldz7l1sp8l9">
                <CheckCircle2 size={16} className="text-success shrink-0" data-id="element-94" data-mp="1fmzefd1sxyym" />{' '}
                Garantía completa de 30 días
              </p>
              <p className="flex items-center gap-2" data-id="element-95" data-mp="576n6fzoizv">
                <CheckCircle2 size={16} className="text-success shrink-0" data-id="element-96" data-mp="48vcnkoz36j0" />{' '}
                Acceso inmediato tras la compra
              </p>
              <p className="flex items-center gap-2" data-id="element-97" data-mp="3ssdwqtzpl946">
                <CheckCircle2 size={16} className="text-success shrink-0" data-id="element-98" data-mp="3nvnk6gn44vni" /> 15
                minutos por noche es todo lo que necesitas
              </p>
              <p className="flex items-center gap-2" data-id="element-99" data-mp="6kxsx4texzgh">
                <CheckCircle2 size={16} className="text-success shrink-0" data-id="element-100" data-mp="1oyzv3x53t9q" />{' '}
                Diseñado para mujeres de más de 35 años
              </p>
            </div>
          </div>

          <p className="text-xs text-dark/50 mt-6 italic" data-id="element-101" data-mp="35560f1k9daea">
            Al completar tu compra recibirás acceso inmediato a todos los
            materiales en formato digital PDF. Compatible con todos los
            dispositivos.
          </p>
        </div>

        <div className="mt-12 text-cream/80 text-lg" data-id="element-102" data-mp="3f0r20ylf08ni">
          <p className="font-bold text-white mb-2" data-id="element-103" data-mp="2rc7s6empvntb">
            La única decisión equivocada es no tomar ninguna.
          </p>
          <p data-id="element-104" data-mp="2mdwh60kor79i">Tu cuerpo lleva tiempo pidiéndote esto.</p>
          <p data-id="element-105" data-mp="1pnklay8moj7n">Esta noche puedes empezar a escucharlo.</p>
        </div>
      </div>
    </section>;
}